(function () {
  'use strict';

  var STORAGE_KEY = 'zillaA11yPrefs';
  var TEXT_LEVELS = ['zilla-a11y-text--2', 'zilla-a11y-text--1', '', 'zilla-a11y-text-1', 'zilla-a11y-text-2', 'zilla-a11y-text-3'];
  var TEXT_DEFAULT_INDEX = 2;

  var TOGGLE_CLASSES = [
    'contrast',
    'grayscale',
    'highlight-links',
    'readable-font',
    'line-spacing',
    'pause-animations',
    'reading-guide',
    'big-cursor'
  ];

  function readPrefs() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return { textIndex: TEXT_DEFAULT_INDEX, toggles: {} };
      var parsed = JSON.parse(raw);
      return {
        textIndex: typeof parsed.textIndex === 'number' ? parsed.textIndex : TEXT_DEFAULT_INDEX,
        toggles: parsed.toggles || {}
      };
    } catch (e) {
      return { textIndex: TEXT_DEFAULT_INDEX, toggles: {} };
    }
  }

  function writePrefs(prefs) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) - degrade gracefully, state stays in-memory for this page view */
    }
  }

  var prefs = readPrefs();
  var root = document.documentElement;

  function applyTextLevel(index) {
    TEXT_LEVELS.forEach(function (cls) {
      if (cls) root.classList.remove(cls);
    });
    var cls = TEXT_LEVELS[index];
    if (cls) root.classList.add(cls);
    prefs.textIndex = index;
    writePrefs(prefs);
  }

  function setToggle(name, on) {
    var cls = 'zilla-a11y-' + name;
    root.classList.toggle(cls, on);
    prefs.toggles[name] = on;
    writePrefs(prefs);
    updateOptionButton(name, on);
    if (name === 'reading-guide') {
      readingGuideEl.hidden = !on;
      if (!on) readingGuideEl.style.top = '-100px';
    }
  }

  function updateOptionButton(name, on) {
    var btn = document.querySelector('[data-zilla-a11y-toggle-class="' + name + '"]');
    if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function resetAll() {
    applyTextLevel(TEXT_DEFAULT_INDEX);
    TOGGLE_CLASSES.forEach(function (name) {
      setToggle(name, false);
    });
  }

  // ---- Apply saved prefs on load ----
  applyTextLevel(prefs.textIndex);
  TOGGLE_CLASSES.forEach(function (name) {
    if (prefs.toggles && prefs.toggles[name]) {
      root.classList.add('zilla-a11y-' + name);
    }
  });

  // ---- Wire up UI once DOM is ready ----
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var readingGuideEl;

  ready(function () {
    var root_el = document.querySelector('[data-zilla-a11y]');
    if (!root_el) return;

    var toggleBtn = document.getElementById('zilla-a11y-toggle');
    var panel = document.getElementById('zilla-a11y-panel');
    var closeBtn = root_el.querySelector('[data-zilla-a11y-close]');
    readingGuideEl = root_el.querySelector('[data-zilla-a11y-reading-guide-el]');

    // Reflect any prefs restored above into the button states now that they exist in the DOM.
    TOGGLE_CLASSES.forEach(function (name) {
      updateOptionButton(name, !!(prefs.toggles && prefs.toggles[name]));
    });
    if (prefs.toggles && prefs.toggles['reading-guide']) {
      readingGuideEl.hidden = false;
    }

    function openPanel() {
      panel.hidden = false;
      toggleBtn.setAttribute('aria-expanded', 'true');
      var firstOption = panel.querySelector('button, a');
      if (firstOption) firstOption.focus();
    }

    function closePanel(returnFocus) {
      panel.hidden = true;
      toggleBtn.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggleBtn.focus();
    }

    toggleBtn.addEventListener('click', function () {
      if (panel.hidden) openPanel();
      else closePanel(false);
    });

    closeBtn.addEventListener('click', function () {
      closePanel(true);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        closePanel(true);
      }
    });

    document.addEventListener('click', function (e) {
      if (!panel.hidden && !root_el.contains(e.target)) {
        closePanel(false);
      }
    });

    root_el.querySelectorAll('[data-zilla-a11y-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.getAttribute('data-zilla-a11y-action');
        if (action === 'text-increase') {
          applyTextLevel(Math.min(prefs.textIndex + 1, TEXT_LEVELS.length - 1));
        } else if (action === 'text-decrease') {
          applyTextLevel(Math.max(prefs.textIndex - 1, 0));
        } else if (action === 'text-reset') {
          applyTextLevel(TEXT_DEFAULT_INDEX);
        }
      });
    });

    root_el.querySelectorAll('[data-zilla-a11y-toggle-class]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-zilla-a11y-toggle-class');
        var isOn = root.classList.contains('zilla-a11y-' + name);
        setToggle(name, !isOn);
      });
    });

    var resetBtn = root_el.querySelector('[data-zilla-a11y-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        resetAll();
      });
    }

    // Reading guide follows the cursor while enabled.
    document.addEventListener('mousemove', function (e) {
      if (!root.classList.contains('zilla-a11y-reading-guide')) return;
      readingGuideEl.style.top = (e.clientY - 22) + 'px';
    });
  });
})();
